import {StyleSheet} from 'react-native';

export const SingleScanStyles = StyleSheet.create({
  scanner: {flex: 1},
});

export const ScannerStyles = StyleSheet.create({
  mainContainer: {flex: 1},
  NoDevice: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    paddingHorizontal: 10,
  },
  opemSettingButton: {padding: '2%', marginTop: 10},
  loaderContainer: {
    position: 'absolute',
    justifyContent: 'center',
    zIndex: 5,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  modalBody: {
    zIndex: 100,
    backgroundColor: 'white',
    paddingVertical: 5,
    borderRadius: 5,
    paddingHorizontal: 30,
    position: 'absolute',
    alignItems: 'center',
    bottom: 150,
    left: 50,
  },
  highlightText: {
    borderRadius: 20,
    padding: 5,
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  overlay: {
    flex: 1,
  },
  unfocusedArea: {
    flex: 3,
  },
  focusedArea: {
    flex: 2,
    flexDirection: 'row',
  },
  clearArea: {
    flex: 20,
    borderWidth: 2,
    backgroundColor: 'transparent',
  },
  instructions: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 32,
  },
  instructionsText: {
    color: '#fff', // light pink
    textAlign: 'center',
    fontWeight: '400',
  },
  exposureBox: {
    position: 'absolute',
    top: 40,
    zIndex: 10,
    height: '50%',
    right: 5,
  },
  cameraIcon: {
    marginBottom: 10,
  },
  scanButton: {backgroundColor: 'transparent'},
  scanBox: {width: '80%'},
  cameraOverlay: {flex: 2},
  barcodesContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 20,
    gap: 20,
  },
});

export const SingleSelectScanStyles = StyleSheet.create({
  scanner: {flex: 1},
  buttons: {
    padding: 15,
  },
  buttonContainer: {
    width: '100%',
    backgroundColor: 'black',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
});

export const matrixScanStyles = StyleSheet.create({
  scanner: {flex: 1},
  buttonContainer: {
    backgroundColor: 'transparent',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 12,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  button: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    height: 42,
    width: '90%',
    maxHeight: 42,
    borderColor: 'transparent',
    borderRadius: 5,
    bottom: 24,
  },
  buttonText: {
    fontSize: 14,
    lineHeight: 42,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
    textAlign: 'center',
  },
});

export const ARViewSTyles = StyleSheet.create({
  dataCaptureView: {
    flex: 1,
  },
  toggleContainer: {
    backgroundColor: 'transparent',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 12,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  arBubbleContainer: {
    width: 200,
    height: 50,
    borderRadius: 25,
    flexDirection: 'row',
  },
  arBubbleContent: {
    width: 150,
    height: 50,
    justifyContent: 'center',
    paddingLeft: 10,
  },
  arBubbleHeader: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  arBubbleInfo: {
    fontSize: 12,
  },
  arBubbleImageContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
  arBubbleImage: {
    width: 50,
    height: 50,
  },
});
